"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideosConverter = void 0;
const convertLinks_1 = require("../../common/utils/convertLinks");
const PlaybackConverter_1 = require("../../common/model/PlaybackConverter");
const convertAttachment_1 = require("../../common/utils/convertAttachment");
const CaptionStatus_1 = require("./CaptionStatus");
class VideosConverter {
    // This should be typed as VideoEntity
    static convert(entity) {
        return {
            id: entity.id,
            title: entity.title,
            description: entity.description,
            additionalDescription: entity.additionalDescription,
            releasedOn: new Date(entity.releasedOn),
            playback: PlaybackConverter_1.PlaybackConverter.convert(entity.playback),
            subjects: entity.subjects,
            badges: entity.badges,
            legalRestrictions: entity.legalRestrictions,
            ageRange: entity.ageRange,
            rating: entity.rating,
            yourRating: entity.yourRating,
            bestFor: entity.bestFor,
            createdBy: entity.createdBy,
            language: entity.language,
            links: (0, convertLinks_1.convertLinks)(entity),
            channel: entity.channel,
            channelId: entity.channelId,
            channelVideoId: entity.channelVideoId,
            attachments: entity.attachments.map(convertAttachment_1.convertAttachment) || [],
            contentWarnings: entity.contentWarnings,
            captionStatus: CaptionStatus_1.CaptionStatus[entity.captionStatus] ?? undefined,
            price: entity.price,
            taxonomy: {
                channel: entity.taxonomy?.channel,
                manual: entity.taxonomy?.manual,
            },
            educationLevels: entity.educationLevels,
            cefrLevel: entity.cefrLevel,
            contentCategories: entity.contentCategories,
            maxLicenseDurationYears: entity.maxLicenseDurationYears,
            type: entity.type,
            restrictions: entity.restrictions,
        };
    }
    static convertListView(entity) {
        return { id: entity.id };
    }
}
exports.VideosConverter = VideosConverter;
//# sourceMappingURL=VideosConverter.js.map